import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { BreadcrumbsContext, type Crumb } from './breadcrumbs-context';

export function BreadcrumbsProvider({ children }: { children: ReactNode }) {
  const [crumbs, setCrumbsState] = useState<Crumb[]>([]);

  const setCrumbs = useCallback((next: Crumb[]) => {
    setCrumbsState(next);
  }, []);

  const value = useMemo(() => ({ crumbs, setCrumbs }), [crumbs, setCrumbs]);

  return (
    <BreadcrumbsContext.Provider value={value}>{children}</BreadcrumbsContext.Provider>
  );
}
